import { render, staticRenderFns } from "./ViewSpt.vue?vue&type=template&id=6f5e6ff9&scoped=true&"
import script from "./ViewSpt.vue?vue&type=script&lang=js&"
export * from "./ViewSpt.vue?vue&type=script&lang=js&"
import style0 from "./ViewSpt.vue?vue&type=style&index=0&id=6f5e6ff9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5e6ff9",
  null
  
)

export default component.exports